import React, { useState, useEffect } from 'react'
import { getCommunityOEMDetailsById, DeleteCommunityToOemDetails, getCommunityOEMDetailsCountById } from '../../CommunityActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import PopUp from '../../../../../../presentationals/Popup/Popup.component'

const itemsPerPage = 10;
export default function Mapped({ communityId,filter }) {
    const [TableData, setTableData] = useState([])
    const [loader,setloader] =useState(false)
    const [currentPage ,setcurrentPage] =useState(1)
    const [totalcount,setTotalcount] =useState(0)
    const [popup,setpopup] =useState({show:false ,popupStatus:''})
     const [filterValue,setFilterValue] =useState("")

    useEffect(() => {
        getMappedProductDetailsBycommIdFunction("",currentPage)
        getCommunityOEMDetailsCountByIdFunction("")
    }, [])

      useEffect(()=>{
            setFilterValue(filter)
            setcurrentPage(1)
            // if(filter !== "" && filter !== undefined && filter !== null){
                getMappedProductDetailsBycommIdFunction(filter, 1)
                getCommunityOEMDetailsCountByIdFunction(filter)
            // }x
        },[filter])

    const getMappedProductDetailsBycommIdFunction = (vehicleType,currentPageNo) => {
        setloader(true)
        getCommunityOEMDetailsById(communityId,vehicleType,currentPageNo,itemsPerPage, (callback) => {
            setloader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    const getCommunityOEMDetailsCountByIdFunction = (vehicleType)=>{
        getCommunityOEMDetailsCountById(communityId,vehicleType,(callback)=>{
            console.log("calls", callback)
            if(callback && callback?.status == 200 && callback?.message == "success"){
                setTotalcount(callback?.data)
            }else{
                setTotalcount(0)
            }
        })
    }

    const paginationHandler = (type) => {
        if (type == 'left') {
            if (currentPage > 1) {
                setcurrentPage((prev)=>prev-1)
                getMappedProductDetailsBycommIdFunction(filterValue,currentPage - 1)
            } else {
                setcurrentPage((prev)=>prev)
            }
        }
        if (type == 'right') {
            if (currentPage < Math.ceil(totalcount / itemsPerPage)) {
                setcurrentPage((prev)=>prev + 1)
                getMappedProductDetailsBycommIdFunction(filterValue,currentPage + 1)
            } else {
                setcurrentPage((prev)=>prev)
            }
        }
    }

    const handleToggle = (id) => {
       
        setloader(true)
        DeleteCommunityToOemDetails(communityId,id, (callback) => {
            setloader(false)
            console.log("call", callback)
            if(callback && callback?.status == 200 && callback?.message == "success"){
                setpopup({show:true,popupStatus:"OEM Unmapped Successfully"})
                getMappedProductDetailsBycommIdFunction("",currentPage)
            }else{
                setpopup({show:true,popupStatus:"Failure"})
            }
            removePopup()
        })
    }

    const closePopup =()=>{
        setpopup({show:false,popupStatus:''})
    }

    const removePopup = ()=>{
        setTimeout(()=>{
            closePopup()
        },5000)
    }
    return (
        <>
        {
            loader ? <Loader /> :''
        }
        {
            popup.show == true ? <PopUp  popupStatus={popup.popupStatus} closePopup={closePopup}/> :''
        }
            {TableData && TableData?.length > 0 ?
                <div style={{ marginTop: '30px' }}>
                    <div className='overflow-auto'>
                        <table className='phocket-table'>
                            <thead style={{ backgroundColor: '#182D64' }}>
                                <tr>
                                    {/* <th>Product Id</th> */}
                                    <th>Vehicle Type</th>
                                    <th>Make</th>
                                    <th>Make Class</th>
                                    <th>Variant</th>
                                    <th>Model</th>
                                    <th>Year</th>
                                    <th>OEM Mapped</th>

                                </tr>
                            </thead>
                            <tbody>
                                {TableData?.map((nbfc, i) => {
                                    return (
                                        <>

                                            <tr key={i}>
                                                {/* <td>{nbfc?.productId || "-"}</td> */}
                                                <td>{nbfc?.vehicleType || "-"}</td>
                                                <td>{nbfc?.make || "-"}</td>
                                                <td>{nbfc?.makeClass || "-"}</td>
                                                <td>{nbfc?.variant || "-"}</td>
                                                <td>{nbfc?.model || "-"}</td>
                                                <td>{nbfc?.year || "-"}</td>
                                                <td>
                                                    <div className="togglableSwitch">
                                                        <label class="toggle-switch">
                                                            <input type="checkbox"
                                                                checked={true}
                                                                onChange={() => handleToggle(nbfc.oemId)}
                                                            />
                                                            <div class="toggle-switch-background">
                                                                <div class="toggle-switch-handle"></div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>

                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" style={{background:'rgb(24, 45, 100)'}} id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                            <div className="col-sm-2 col-xs-12  phoc text-center" >Total: {currentPage}&nbsp; of &nbsp; {Math.ceil(totalcount / itemsPerPage)}</div>
                            <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" style={{background:'rgb(24, 45, 100)'}} id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                    </div>
                </div>
                : ''}
        </>
    )
}
